<template lang="pug">
    .v-container
        v-settings-table(
            :titles="titles"
            :translationPath="translationPath"
            :items="types"
            :saveAction="saveAction"
            :saveMutation="saveMutation"
            :existingTypes="existingTypes"
            :backUrl="backUrl"
            @existingTypesChange="existingTypesChange($event)"
        )
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SettingsTable from '@/components/SettingsTable'

export default {
    components: {
        'v-settings-table': SettingsTable
    },
    data: () => ({
        titles: ['loggingType', 'activation'],
        translationPath: {
            headers: '$vuetify.pages.SystemLogs.settings',
            data: '$vuetify.pages.SystemLogs.types'
        },
        backUrl: { path: '/system-logs' },
        getAction: '',
        saveAction: 'systemLogs/updateTypes',
        saveMutation: 'systemLogs/SET_TYPES',
        existingTypes: []
    }),
    computed: {
        ...mapGetters(['type']),
        ...mapState({
            types: state => state.systemLogs.types
        })
    },
    created() {
        this.$store.dispatch('systemLogs/getTypes').then(() => {
            this.existingTypes = [...this.types.map(it => Object.assign({}, it))]
        })
    },
    methods: {
        existingTypesChange(data) {
            this.existingTypes = data.existingTypes
        }
    }
}
</script>

